import React, {useState} from "react";
import {UploadOutlined} from '@ant-design/icons';
import {
    Button,
    Divider,
    Upload,
    Space,
    Spin,
    Modal
} from 'antd';
import * as util from '../Helpers/Util';
import yibfExcelUpload from '../../services/yibfExcelUpload';

const YibfExcelUploadForm = () => {


    const [file, setFile] = useState();
    const [uploading, setUploading] = useState(false);
    const [resultMsg, setResultMsg] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleUpload = async () => {
        setUploading(true);

        const formData = new FormData();

        formData.append('Files', file);

        await yibfExcelUpload(formData).then(resp => {
            console.log(resp);
            if(resp.data.success){
                setResultMsg("İşlem başarıyla tamamlanmıştır . \n " + 
                              "Başarıyla eşleştirilen kayıt sayısı : " + resp.data.result.EslestirilenCount + " \n" +
                              "Eşleştirilemeyen kayıt sayısı : " + resp.data.result.EslestirilmeyenCount + " \n " +
                              "Yüklenemeyen kayıt sayısı  : " + resp.data.result.YuklenemeyenCount );
            }else{
                setResultMsg(resp.data.message);
            }
            setIsModalVisible(true);
        }).catch(ex => {
            setResultMsg(String(ex.message));
            setIsModalVisible(true);
        });

        setUploading(false);
    };
    const handleOkCancel = () => {
        setIsModalVisible(false);
        window.location.reload();
      };
    
    return (
        <>
            <Spin tip="Excel işleniyor. Lütfen bekleyiniz."
                spinning={uploading}
                style={
                    {marginTop: "10%"}
            }>
                <Divider>
                    YİBF Listesi Yükle</Divider>
                <Space direction="horizontal"
                    style={
                        {
                            width: "100%",
                            justifyContent: "center"
                        }
                    }
                    size="large">
                    <Upload accept=".xls,.xlsx"
                        onRemove={
                            () => {
                                setFile(undefined)
                            }
                        }
                        beforeUpload={
                            (file) => {
                                setFile(file);
                                return false;
                            }
                        }
                        maxCount={1}>
                        <Button icon={<UploadOutlined/>}>Dosya Seç</Button>
                    </Upload>
                    <Button type="primary"
                        onClick={handleUpload}
                        disabled={
                            util.isNullOrEmptyOrUndefined(file)
                        }
                        loading={uploading}>
                        {
                        uploading ? 'Yükleniyor...' : 'Yükle'
                    } </Button>
                </Space>
            </Spin>

            <Modal title="Excel Yükleme"
                visible={isModalVisible}
                onOk={handleOkCancel}
                onCancel={handleOkCancel}>
                 <p>
                    {resultMsg}
                 </p>
            </Modal>
        </>
    );
}

export default YibfExcelUploadForm;

